// Business profile + workspace settings (tenant-scoped).
import { apiClient } from "../apiClient";

const send = (url, method, body) => apiClient(url, { method, body: JSON.stringify(body) }).then((res) => res.data);

export const getBusinessProfile = () => apiClient("/api/business-profile").then((res) => res.data);
export const saveBusinessProfile = (patch) => send("/api/business-profile", "PATCH", patch);
export const getWorkspaceSettings = () => apiClient("/api/settings").then((res) => res.data);
export const saveWorkspaceSettings = (settings) => send("/api/settings", "PUT", settings);
export const getBusinessHours = () => apiClient("/api/business-hours").then((res) => res.data);
export const saveBusinessHours = (doc) => send("/api/business-hours", "PUT", doc);
